// @Version: 1.0.0
import { Directive, ElementRef, Input, OnInit, Renderer2 } from "@angular/core";
import { Router,RouterEvent, Event } from "@angular/router";
import { filter } from "rxjs";

@Directive({
    selector: '[setClassUrl]',
    standalone: false
})
 export class SetClassUrlDirective implements OnInit {
   
   @Input() className: string = "active";
   @Input() setClassUrl!: string;

   //-1 letzter Abschnitt
   //alles andere pos nach der Raute, beginnend mit 1

   @Input() pos: number = -1;

   constructor (private elemRef: ElementRef, private renderer: Renderer2, private router: Router) {
   }

   ngOnInit(): void {
      this.router.events.pipe(      
         filter((e: Event | RouterEvent): e is RouterEvent => e instanceof RouterEvent)    
      ).subscribe((elem: RouterEvent) => {
         this.setClass(elem.url); 
      })
      
      this.setClass(this.router.url);
   }

   private setClass (url: string): void {
      let splitUrl = url.split("/");
      let find: boolean = false; 

      if (this.pos == -1) find = splitUrl[splitUrl.length - 1] == this.setClassUrl;
      else find = splitUrl[this.pos] == this.setClassUrl; 

      find ? this.renderer.addClass(this.elemRef.nativeElement, this.className) : this.renderer.removeClass(this.elemRef.nativeElement, this.className);
   }
}